// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AWqHukFYO3XnHx {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0;
  margin-right: 10px;
  padding: 0;
  overflow: hidden;
  border: none;
  border-radius: 4px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  cursor: default;
}
.h0JQcDqFb_frB7 {
  cursor: pointer;
}
.h0JQcDqFb_frB7:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .h0JQcDqFb_frB7:focus {
  outline-color: -webkit-focus-ring-color;
}
.h0JQcDqFb_frB7:focus .mac.firefox {
  outline-color: AccentColor;
}
.h0JQcDqFb_frB7:hover {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.h0JQcDqFb_frB7:hover .MgaBQ8XfnP7l17 {
  display: block;
  text-decoration: underline;
}
.h0JQcDqFb_frB7:active {
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
}
.h0JQcDqFb_frB7:active .MgaBQ8XfnP7l17 {
  background: var(--ds-interaction-pressed, #00000052);
}
.MgaBQ8XfnP7l17 {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 32px;
  background: var(--ds-interaction-hovered, rgba(0, 0, 0, 0.5));
  color: var(--ds-text-inverse, #ffffff);
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 32px;
  text-align: center;
}
.aGxy2bEiXdM17D {
  padding: 0;
}
.aGxy2bEiXdM17D svg {
  width: 55px;
  height: 55px;
}
.NjFGISA3gBcdVb {
  width: 60px;
  height: 60px;
  background-size: 60px 60px;
  object-fit: cover;
}
.MvLWtqmqwKjCif {
  color: var(--ds-text-danger, #ae2a19);
}
.eUd4YL8dD3Uu5d {
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  height: 34px;
  margin: 0;
  padding: 0;
  clear: both;
  cursor: pointer;
}
.eUd4YL8dD3Uu5d input[type='file'] {
  margin-bottom: 0;
}
.O7ELINVO9Fu2nR {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}
.My1uFQYsQYrKY7 {
  margin: 8px 0 0 0;
}
.l5dW_qvWxbxzMC {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  font-size: 35px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AWqHukFYO3XnHx`,
	"isEditable": `h0JQcDqFb_frB7`,
	"profileImageText": `MgaBQ8XfnP7l17`,
	"profileIcon": `aGxy2bEiXdM17D`,
	"profileImage": `NjFGISA3gBcdVb`,
	"error": `MvLWtqmqwKjCif`,
	"uploader": `eUd4YL8dD3Uu5d`,
	"hideInput": `O7ELINVO9Fu2nR`,
	"popoverButton": `My1uFQYsQYrKY7`,
	"workspaceDefaultLogo": `l5dW_qvWxbxzMC`
};
export default ___CSS_LOADER_EXPORT___;
